
import React from 'react';
import { connect } from 'react-redux';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import { setUserDetails } from '../../General/Actions.js';
import { setCache } from '../../General/Actions.js';
import ApuaBlueTextLogo from '../../ImageAssets/Apua_New_Logo.png';
// import ApuaBlueTextLogo from '../../ImageAssets/ApuaBlueTextLogo.png';
import Dot from '../../ImageAssets/dots.png';
import { FaUser } from 'react-icons/fa';
import { Button } from 'reactstrap';
import PopupModal from '../../Utils/modalComponent.js';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo_White.png';
import blueBanner from '../../ImageAssets/blueBanner.png';
import SliderModal from '../../Utils/sliderModal.js';

class SelectAllServiceComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            accountName: "",
            allAccountList: [],
            contentForPopup: "",
            headingForPopup: "",
            isSubmitButtonVisibleForPopup: true,
            isCancelButtonVisibleForPopup: true,
            isSwalVisible: false,
            selectedService: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.setState({ "dummy": "dummy" })
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    optionsButtonClicked(type, needConfirmation) {
        if (type === "logout") {
            if (needConfirmation) {
                Swal.fire({
                    title: this.props.locales.logoutConfirmationTitleInSwal,
                    text: "",
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { this.optionsButtonClicked("logout"); }
                });
            } else {
                Network.executeAxios("logout", "GET", {}, (response) => {
                    if (response.STATUS === "SUCCESS") {
                        localStorage.removeItem("isUserLoggedIn");
                        localStorage.removeItem("currentAccount");
                        localStorage.removeItem("currentService");
                        window.location.reload()
                    } else {
                        Swal.fire(this.props.locales.selectAllAccCompLogoutFailedSwal, "", "");
                    }
                });
            }
        }
    }

    showSwal = (title, message, type, callback) => {
        this.setState({
            isSwalVisible: true,
            headingForPopup: title,
            contentForPopup: message
        })
        this.state.swalCallBack = callback
        this.setState({ "dummy": "dummy" })
    }

    customSwalEvent = (dataObject) => {
        if (dataObject.type === "cancel") {
            if (this.state.swalCallBack) {
                this.setState({ isSwalVisible: false, swalCallBack: false });
            }
        } else {
            if (this.state.swalCallBack) {
                this.state.swalCallBack()
                this.setState({
                    isSwalVisible: false
                })
            }
        }
    }

    selectAccountLinkClicked(receivedId) {
       this.setState({selectedService: receivedId})
    }

    allServiceModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.optionsButtonClicked("logout")
        } else if(dataObject.type === "submit") {
            this.props.setUserDetails("currentService", this.state.selectedService);
            this.props.reInitialize(this.state.selectedService);
        }
    }

    populateAllAcounts() {
        var finalAccountList = [];
        var values = [];
        var value;
        for (var i = 0; i < this.props.cache.serviceListResponse.length; i++) {
            value = this.props.cache.serviceListResponse[i].service_id;

            if (values.indexOf(value) == -1) {
                finalAccountList.push(this.props.cache.serviceListResponse[i].service_id);
                values.push(value);
            }
        }
        var allServices = this.props.cache.serviceListResponse;
        const allAccounts = allServices.map((item, key) => {
            var isSelected = false;
            if(item.service_id === this.state.selectedService) isSelected = true;
            return (
                <div className={isSelected ? "allAddonDetailForAddonInactive activeAddoncard d-flex mx-auto align-items-center py-4 mb-3" : "allAddonDetailForAddonInactive d-flex mx-auto align-items-center py-4 mb-3"} key={key}
                onClick={() => this.selectAccountLinkClicked(item.service_id)}>
                    <div className="d-flex mx-auto align-items-center" >
                        <div className="p-0" style={{ width: '100%' }}>
                            <div className="" style={{ fontSize: 14, fontWeight: 500, color: '#FFFFFF' }}>{item.service_id}</div>
                        </div>
                    </div>
                </div>
            );
        });
        return (<div className="allAccountDetailContainer col-md-12 row py-5" style={{ backgroundColor: 'transparent' }}>{allAccounts}</div>)
    }

    render() {
        return (
            <div className="animated fadeIn" id="allAccountsMainDiv" style={{ height: this.state.windowHeight + 100 + 'px' }}>
                {/* {this.topBannerComponent()} */}

                
                <div className="col-md-12 p-0 m-0" style={{display:"flex",flex:1,flexDirection:"column"}}>
                    <div className='p-5' style={{  backgroundImage: `url(${blueBanner})`,backgroundRepeat:"no-repeat",backgroundSize:"100% 100%"}}>
                        <div className='pb-5' style={{}}>
                            <img alt="" src={ApuaWhiteTextLogo} />
                        </div>
                    </div>
                </div> 


                {/* <div className="col-md-12 p-0" style={{ backgroundColor: '#ffffff' }}>
                    <div className=" d-flex justify-content-between py-3 align-items-center" style={{ backgroundColor: '#ffffff', width: '88%', marginLeft: 'auto', marginRight: 'auto', minHeight: 70 }}>
                        <div className="text-left headerImage"><img src={ApuaBlueTextLogo} alt="" height="55" /></div>
                        <div className="text-right d-flex">
                            <div className="d-flex align-items-center">
                                <div className="" style={{ color: '#414042', fontWeight: 500, fontSize: 16 }}>{this.state.accountName}</div>
                            </div>
                            <div>
                                <Button color="link" className="logoutButton ml-3" style={{ backgroundColor: 'rgba(0,73,165,0.1)', color: '#0049A5', borderRadius: '50%' }} onClick={() => { this.optionsButtonClicked("logout", true) }}><FaUser style={{ marginTop: '-5' }} /></Button>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div className="populateAccountDiv">
                    <div className="col-md-12" style={{ height: 145, position: 'relative', boxShadow: 'rgb(0 0 0 / 15%) 0px 8px 20px -8px inset' }}>
                        <div className="ml-auto mr-auto pt-4" style={{ width: '89%' }}>
                            <div style={{ fontSize: 24, color: '#33495F' }}>{this.props.locales.welcomeTextInOverview} <span style={{ fontWeight: 500 }}> {this.state.accountName} </span></div>
                            <div style={{ fontSize: 14, color: '#33495F' }}>{this.props.locales.selectAllAccCompSelectAnAccTxt}</div>
                        </div>
                        <div style={{ position: 'absolute', background: `url(${Dot})`, height: 100, width: 150, top: 0, right: 0 }}></div>
                    </div> */}



                <SliderModal
                    isVisible={true}
                    uniqueModalReferenceId="callMeBack"
                    mainHeading="Select a service"
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Proceed"
                    isSubmitButtonDisabled = {this.state.selectedService === "" ? true : false}
                    callback={this.allServiceModalHandler}
                >
                   <div className="col-md-12">
                        {this.populateAllAcounts()}
                    </div>

                </SliderModal>


                {/* </div> */}
                <PopupModal
                    isVisible={this.state.isSwalVisible}
                    uniqueModalReferenceId=""
                    content={this.state.contentForPopup}
                    mainHeading={this.state.headingForPopup}
                    isCancelButtonVisible={this.state.isCancelButtonVisibleForPopup}
                    isSubmitButtonVisible={this.state.isSubmitButtonVisibleForPopup}
                    cancelButtonText={this.state.cancelButtonText}
                    callback={this.customSwalEvent}
                />
            </div>

        );
    }

    // topBannerComponent() {
    //     return (
    //         <div className="py-1" style={{ background: 'linear-gradient(90deg, #FF0026 0%, #E21736 100%)', width: '100%' }}>
    //             <div style={{marginLeft:'auto',marginRight:'auto',width:'88%'}} className=" d-flex justify-content-between">
    //                 <div className="" style={{color:"#ffffff",fontWeight:500,fontSize:16,cursor:'pointer'}}
    //                     onClick={(e) => {
    //                         e.preventDefault();
    //                         window.location.href='https://www.hargray.com/contact-us';
    //                       }}>
    //                  <span style={{textDecoration:'underline'}}>Contact us</span>  <span style={{ marginLeft:10}}>(877.427.4729)</span>
    //                 </div>
    //                 <div className="" style={{color:"#ffffff",fontWeight:500,fontSize:16,cursor:'pointer'}}
    //                 onClick={(e) => {
    //                     e.preventDefault();
    //                     window.location.href='https://www.hargray.com/support';
    //                     }}>
    //                     FAQ
    //                 </div>


    //             </div>
    //         </div>
    //     );
    // }

    topBannerComponent() {
        return (
            <div className="py-1" style={{ backgroundColor: 'rgba(0,0,0,0.9)', width: '100%' }}>
                <div style={{ marginLeft: 'auto', marginRight: 'auto', width: '88%' }} className=" d-flex justify-content-between">
                    <div className="" style={{ color: "#ffffff", fontSize: 16, cursor: 'pointer' }}
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = 'https://www.hargray.com';
                        }}>
                        <span style={{ fontWeight: 500 }}>MY HARGRAY</span>
                        <span style={{ marginLeft: 55 }}>SHOP/UPGRADE</span>
                        <span style={{ marginLeft: 55 }}>SUPPORT</span>
                        <span style={{ marginLeft: 55 }}>BUSINESS</span>
                    </div>
                    <div className="" style={{ color: "#ffffff", fontSize: 16, cursor: 'pointer' }}
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = 'https://www.hargray.com/support';
                        }}>
                        FAQ
                    </div>


                </div>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload));
        }
    }
}

const SelectAllServiceComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectAllServiceComponent)

export default SelectAllServiceComponentContainer;
